import { lazy } from "react";

export { TASK_PATH } from "./task-path";
export const Task = lazy(() => import("./task"));
export { ToTask } from "./to-task";
